import { Charts } from './Charts';
import HouseholdRelationshipChartsDataProvider from './contexts/HouseholdRelationshipChartsDataContext';

const HouseholdRelationshipWrapper = () => {
    return (
        <HouseholdRelationshipChartsDataProvider>
            <Charts />
        </HouseholdRelationshipChartsDataProvider>
    );
};

export default HouseholdRelationshipWrapper;
